import React, { useState } from "react";
import "./headboard-two.scss";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import { RiShareForwardFill } from "@react-icons/all-files/ri/RiShareForwardFill";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import Button from "../../atoms/button/button";
import ShareModal from "../../molecules/ShareModal/ShareModal";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

const HeadboardTwo = (props: ReferenciaCabecera) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };

  return (
    <div className="o-headboard-two">
      <ShareModal
        open={isModalVisible}
        onClose={toggleModal}
        gtmClass={`gtm${normalizeTwoWords(
          props.tituloPrincipal
        )}Articulo${normalizeTwoWords(props.tituloPrincipal)}Compartir`}
      />
      <div className="o-headboard-two__container">
        <Breadcrumb content={props.migaDePan} />
        <div className="o-headboard-two__container__content">
          {props.tituloPrincipal && (
            <h1
              className="o-headboard-two__container__content__title"
              dangerouslySetInnerHTML={{ __html: props.tituloPrincipal }}
            ></h1>
          )}
          <></>
          <div className="o-headboard-two__container__content__btns">
            <Button
              onClickAction={toggleModal}
              text=" compartir"
              isDisabled={false}
              classname="o-headboard-two__container__content__btns__btn"
              IconAlt={<RiShareForwardFill />}
              type="button"
            />
          </div>
          <div className="o-headboard-two__container__content__text">
            {props.descripcion &&
              props.descripcion.json.content.map((paragraph, key) => (
                <article
                  className="o-headboard-two__container__content__text__paragraph"
                  key={key}
                >
                  {paragraph.content[0].value}
                </article>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeadboardTwo;
